module.exports = __webpack_public_path__ + "img/MBT_R_FOS.05677b89.png";